import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout'
import RouterView from '@/views/routerview'

Vue.use(Router)

export const staticRouters = [{
        path: '/login',
        name: 'login',
        component: () =>
            import ('@/views/login'),
        meta: { noauth: true }
    },
    { path: '*', redirect: '/login' }
];

export const dynamicRouters = [{
    path: '/',
    component: Layout,
    hiddens: {
        'my_detail': () =>
            import ('@/views/first/my_detail'),
        'password_detail': () =>
            import ('@/views/first/password_detail'),
    },
    children: [{
            path: 'first',
            name: 'first',
            component: () =>
                import ('@/views/first'),
            meta: { title: '首页', icon: 'odometer', frame: false },
        },
        // {
        // 	path: 'demo_list',
        // 	name: 'demo_list',
        // 	component: () => import('@/views/demo_list'),
        // 	hiddens: {
        // 		'demo_detail': () => import('@/views/demo_detail'),
        // 	},
        // 	meta: {title: '例子',icon: 'document'}
        // },
        {
            path: 'user',
            meta: { title: '用户管理', icon: 'folder' },
            component: RouterView,
            children: [{
                path: 'user_list',
                name: 'user_list',
                component: () =>
                    import ('@/views/user_list'),
                meta: { title: '用户列表', icon: 'document' }
            }, ]
        },
        {
            path: 'wrong',
            meta: { title: '错题管理', icon: 'folder' },
            component: RouterView,
            children: [
                {
                    path: 'wrong_list',
                    name: 'wrong_list',
                    component: () =>
                        import ('@/views/wrong/wrong_list'),
                    meta: { title: '错题列表', icon: 'document' }
                },
                {
                    path: 'paper_list',
                    name: 'paper_list',
                    component: () =>
                        import ('@/views/wrong/paper_list'),
                    hiddens: {
                        'paper_detail': () =>
                            import ('@/views/wrong/paper_detail'),
                    },
                    meta: { title: '试卷列表', icon: 'document' }
                },
            ]
        },
        {
            path: 'news',
            meta: { title: '运营管理', icon: 'folder' },
            component: RouterView,
            children: [
                {
                    path: 'news_list',
                    name: 'news_list',
                    component: () =>
                        import ('@/views/news/news_list'),
                    hiddens: {
                        'news_detail': () =>
                            import ('@/views/news/news_detail'),
                    },
                    meta: { title: '资讯列表', icon: 'document' }
                },
                {
                    path: 'ads_list',
                    name: 'ads_list',
                    component: () =>
                        import ('@/views/ads/ads_list'),
                    hiddens: {
                        'ads_detail': () =>
                            import ('@/views/ads/ads_detail'),
                    },
                    meta: { title: ' 广告管理', icon: 'document' }
                },
            ]
        },
        {
            path: 'book',
            meta: { title: '语文助手', icon: 'folder' },
            component: RouterView,
            children: [
                {
                    path: 'grade_list',
                    name: 'grade_list',
                    component: () =>
                        import ('@/views/textbook/grade/grade_list'),
                    hiddens: {
                        'grade_detail': () =>
                            import ('@/views/textbook/grade/grade_detail'),
                    },
                    meta: { title: '年级列表', icon: 'document' }
                },
                {
                    path: 'textbook_list',
                    name: 'textbook_list',
                    component: () =>
                        import ('@/views/textbook/textbook/textbook_list'),
                    hiddens: {
                        'textbook_detail': () =>
                            import ('@/views/textbook/textbook/textbook_detail'),
                        'page_detail': () =>
                            import ('@/views/textbook/textbook/page_detail'),
                    },
                    meta: { title: '教材列表', icon: 'document' }
                },
                {
                    path: 'poetry_list',
                    name: 'poetry_list',
                    component: () =>
                        import ('@/views/textbook/poetry/poetry_list'),
                    hiddens: {
                        'poetry_detail': () =>
                            import ('@/views/textbook/poetry/poetry_detail'),
                    },
                    meta: { title: '诗词管理', icon: 'document' }
                },
            ]
        },
        {
            path: 'sys',
            meta: { title: '系统管理', icon: 'folder' },
            component: RouterView,
            children: [{
                path: 'sys_user_list',
                name: 'sys_user_list',
                component: () =>
                    import ('@/views/sys_user_list'),
                hiddens: {
                    'sys_user_detail': () =>
                        import ('@/views/sys_user_detail'),
                },
                meta: { title: '管理账号', icon: 'document' }
            }, ]
        },
    ]
}];

export default new Router({
    routes: staticRouters,
    staticRouters: staticRouters,
    dynamicRouters: dynamicRouters
})
